<template>
    <b-modal
            v-if="formData"
            v-model="modalEditUser"
            ref="my-modal"
            id="modal-user"
            centered
            no-close-on-backdrop
            hide-footer
            :title="`${$t('labels.editUser')} @${ formData.userName }`">

        <b-form @submit.prevent="updateForm">
            <b-form-checkbox
                    v-model="formData.status"
                    name="check-button"
                    switch
                    inline>
                <div>
                    {{ $t("labels.userStatus") }} <b>{{ formData.status ? $t("labels.activeStatus") : $t("labels.inactiveStatus") }}</b>
                </div>
                <div>
                  {{$t("labels.userRole")}} <b>{{ userRole(formData.role) }}</b>
                </div>
            </b-form-checkbox>
            <hr>
            <b-form-group :label="$t('labels.userName')">
                <b-form-input
                        v-model="formData.userName"
                        type="text"
                        :placeholder="$t('labels.userName')"
                />
            </b-form-group>

            <b-form-group :label="$t('labels.firstName')">
                <b-form-input
                        v-model="formData.firstName"
                        type="text"
                        :placeholder="$t('labels.firstName')"
                />
            </b-form-group>

            <b-form-group :label="$t('labels.lastName')">
                <b-form-input
                        v-model="formData.lastName"
                        type="text"
                        :placeholder="$t('labels.lastName')"
                />
            </b-form-group>

            <b-form-group :label="$t('labels.password')">
                <validation-provider
                        #default="{ errors }"
                        name="password"
                        :rules="{ required: true, min: 8 }"
                >
                    <b-form-input
                            v-model="formData.password"
                            type="password"
                            :placeholder="$t('labels.password')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </b-form-group>

            <b-form-group :label="$t('labels.confirmPassword')">
                <validation-provider
                        #default="{ errors }"
                        name="Confirm Password"
                        :rules="{ required: true, confirmed: 'password'}"
                >
                    <b-form-input
                            v-model="confirm_password"
                            type="password"
                            :placeholder="$t('labels.confirmPassword')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </b-form-group>

            <b-form-group :label="$t('labels.role')">
                <v-select
                        v-model="formData.role"
                        :placeholder="$t('labels.role')"
                        label="name"
                        :options="dataRoles"/>
            </b-form-group>

            <b-form-group :label="$t('labels.currencies')">
                    <v-select
                            v-model="formData.activeCurrencies"
                            label="name"
                            multiple=""
                            :reduce="currency => currency._id"
                            :close-on-select="false"
                            :options="formData.currencies"
                    />

            </b-form-group>

            <b-form-group :label="$t('labels.defaultCurrency')">
                <v-select
                          v-model="formData.defaultCurrency"
                          label="name"
                          :reduce="currency => currency._id"
                          :options="formData.currencies"
                />
            </b-form-group>

            <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="submit"
                    variant="primary"
                    class="mr-1">
                {{$t('buttons.submit')}}
            </b-button>

        </b-form>
    </b-modal>
</template>

<script>
  import { mapActions } from 'vuex'
  import { VueGoodTable } from 'vue-good-table'
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import {
    BAvatar,
    BBadge,
    BButton,
    BCard,
    BDropdown,
    BDropdownItem,
    BForm,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BOverlay,
    BPagination,
    VBModal,
  } from 'bootstrap-vue'
  import vSelect from 'vue-select'
  import addUpdateUser from './addUpdateUser'
  import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
  import Ripple from 'vue-ripple-directive'

  export default {
    name: 'EditUser',
    components: {
      ValidationObserver,
      ValidationProvider,
      VueGoodTable,
      BAvatar,
      BBadge,
      BPagination,
      BFormGroup,
      BFormInput,
      BFormSelect,
      BDropdown,
      BDropdownItem,
      VBModal,
      BForm,
      BButton,
      vSelect,
      BFormCheckbox,
      BCard,
      addUpdateUser,
      BOverlay,
      ToastificationContent
    },

    directives: {
      'b-modal': VBModal,
      Ripple,
    },

    data(){
      return{
        formData : {
          activeCurrencies : '',
          currencies : '',
          defaultCurrency : '',
          userName : '',
          role : '',
        },
        modalEditUser : false,
        confirm_password: null,
        dataRoles: [],
        active : false,
      }
    },

    methods:{
      ...mapActions('user', ['users', 'destroy', 'update']),
      ...mapActions('role', ['roles']),
      ...mapActions("wallet", ["show"]),

      async updateForm(){
        if( (this.formData.password == this.confirm_password) || (this.formData.password == this.confirm_password) ){

          let response = await this.update(this.formData)
          if(response){
            this.modalEditUser= false
            this.formData = {}
            //this.getUsers()
            this.refreshUserList()
            this.confirm_password = null
            this.$swal({
              title: this.$t('labels.updatedUser'),
              text: response.message,
              icon: 'success',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
          }
        } else {
          this.$swal({
            title: this.$t('labels.error'),
            text: 'Passwords do not match',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })
          return false
        }
      },

      getRoles() {

        // this.roles().then((response)=>{
        //   this.dataRoles = response.roles
        // });

        const rolesWithWallet = ['CUSTOMER','AGENT']
        const rolesWithoutWallet = ['ROOT','SUPER_ADMIN','ADMIN']

        if (rolesWithWallet.includes(this.formData.role))
          this.dataRoles = rolesWithWallet
        else{
          this.dataRoles = rolesWithoutWallet
          const userData = JSON.parse(localStorage.getItem('userData'))
          if (userData.role.toLowerCase() == 'root' || userData.role.toLowerCase() == 'super_admin' )
            this.dataRoles = [rolesWithoutWallet[0],rolesWithoutWallet[1]]
          else if (userData.role.toLowerCase() == 'admin' )
            this.dataRoles = [rolesWithoutWallet[2]]
        }

      },

      userRole(role){
        if(Array.isArray(role) && role.length > 0 ){
          return role.join(', ')
        } else if (role) {
          return role.toString().toUpperCase()
        } else {
          return 'No role'
        }
      },

      getWalletCurrencies(walletData){
        return walletData.currencies.map(currencies => {
          return Object.assign({}, currencies.currency)
        })
      },

      async showModal(formData){
        this.formData.userName = formData.userName
        this.formData.firstName = formData.firstName
        this.formData.lastName = formData.lastName
        this.formData.email = formData.email
        this.formData._id = formData._id
        this.formData.role = formData.role
        this.formData.status = formData.status

        //user with wallet (AGENT or CUSTOMER)
        if (formData.hasOwnProperty('wallet')){
          const userWallet  = await this.show(formData.wallet)
          const clientCurrencies  = formData.client.currencies
          if (userWallet && clientCurrencies){
            this.formData.currencies = clientCurrencies.filter(currencies => currencies.active).map(currency => {
              return Object.assign({}, currency.currency)
            })
            this.formData.defaultCurrency = userWallet.defaultCurrency._id
            const activesCurrencies = userWallet.currencies.filter(currencies => currencies.active).map(currency => {
              return Object.assign({}, currency.currency)
           })
            this.formData.activeCurrencies = activesCurrencies.map(item => item._id);
          }
        }

        this.getRoles()

        this.modalEditUser = true
      },

      hideModal(){
        this.formData = {
          activeCurrencies : '',
          currencies : '',
          defaultCurrency : '',
          userName : '',
          role : '',
        }
        this.modalEditUser = false
      },

      refreshUserList(){
        this.hideModal()
        this.$emit('refreshUserList')
      }

    },

    created() {
     // this.getRoles()
    }

  }
</script>

<style scoped>

</style>